import script from "./KCallout.vue?vue&type=script&setup=true&lang=ts"
export * from "./KCallout.vue?vue&type=script&setup=true&lang=ts"

import "./KCallout.vue?vue&type=style&index=0&id=a4394726&lang=sass"

const __exports__ = script;

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
